<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M21.2 10.5q.2-.5.5-.1a9.2 9.2 0 0 1-11.3 11.3q-.3-.3.2-.5h.8a10 10 0 0 0 9.8-10.7"
    />
    <path
      fill-rule="evenodd"
      d="M11.1 2a9 9 0 0 1 9.2 9.3A9.2 9.2 0 1 1 11 2m0 4.5q-.3 0-.3.2l-.6 3.1q0 .3-.2.2H7.7q-.3 0-.3.2L7.1 12q0 .3.2.3h2.2q.3 0 .2.3l-.5 3q0 .2.2.3h1.9l.2-.2.6-3.2.2-.2h2.3q.2 0 .3-.2l.3-1.8q0-.2-.2-.3h-2.2l-.2-.3.5-2.9q0-.3-.2-.3z"
      clip-rule="evenodd"
    />
  </svg>
</template>
